// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, vendor/assets/javascripts,
// or any plugin's vendor/assets/javascripts directory can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// compiled file.
//
// Read Sprockets README (https://github.com/rails/sprockets//sprockets-directives) for details
// about supported directives.
//
// Lib

// CAPSENS HELPERS

// CHART JS

// STIMULUS


$(document).ready(function () {
  init_auto_submit_form();
  init_copy_btn();
  init_disable_on_click();
  $('.modal.show').modal('show');

  setTimeout(() => {
    $('#profileCompletedModal:not(show)').modal('show');
    $('#popupModal:not(show)').modal('show');
  }, 2000);
});

function init_auto_submit_form() {
  var auto_submit_form = function () {
    var form = $(this).parents('form')[0];

    Rails.fire(form, 'submit');
  };

  $('.auto-input-change').on('change', auto_submit_form);
  $('.auto-input-blur').on('keyup', auto_submit_form);
  $('#popupCtaButton').on('click', auto_submit_form);
}

function init_copy_btn() {
  $('[data-copy-target]').each(function () {
    $(this).on('click', function (event) {
      event.preventDefault();
      document.querySelector($(this).data('copy-target')).select();
      document.execCommand('copy');
    });
  });
}

function init_disable_on_click() {
  $('a[data-disable-on-click]').on('click', (e) => {
    $(e.target).addClass('disabled').attr('disabled', 'disabled');
  });
}

Turbo.session.drive = false;
